import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useSurveyForSettingsQuery } from '~/hooks/useSurveyForSettingsQuery'

import { BrandList } from './components/BrandList'

export const BrandListPage = () => {
  const { isLoading } = useSurveyForSettingsQuery()

  return (
    <Suspense loading={isLoading}>
      <BrandList />
    </Suspense>
  )
}
